export function getSqlPEResourceIDAndName(serverName: string, serverResourceID: string, groupID?: string): {
    id: string,
    name: string,
    groupID?: string
} {
    let resourceName: string = '';
    if (serverName) {
        const index = serverName.indexOf(':');
        resourceName = index < 0 ? serverName.split('.')[0] : serverName.substr(index + 1).split('.')[0];
        if (groupID === 'sqlOnDemand') {
            const index = resourceName.indexOf('-ondemand');
            if (index > 0) {
                resourceName = resourceName.substr(0, resourceName.indexOf('-ondemand'));
            }
        }
        if (!resourceName || serverResourceID && !serverResourceID.endsWith('/' + resourceName)) {
            serverResourceID = undefined;
        }
    } else {
        serverResourceID = undefined;
    }
    return {
        id: serverResourceID,
        name: resourceName,
        groupID
    };
}
